"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLLECTION = void 0;
exports.COLLECTION = {
    APP_REVIEW_CONFIG: 'AppReviewConfig',
    APP_UPDATE: 'AppUpdate',
    ARCHIVE: 'Archive',
    TASK_QUEUE: 'TaskQueue',
    OUTBOX: 'Outbox',
    PAYWALL_CONFIG: 'PaywallConfig',
    USER_PROFILE: 'UserProfile',
    SCAN_STATUS: 'ScanStatus',
    REPORT_GENERATION_STATUS: 'ReportGenerationStatus',
    WEEKLY_REPORT_GENERATION_STATUS: 'WeeklyReportGenerationStatus',
    WEARABLE_SYNC_STATUS: 'WearableSyncStatus',
};
//# sourceMappingURL=models.js.map